import { http } from '@/lib/http';

/**
 * Public, source-of-truth document versions. Cached server-side (~30s).
 * No auth required — versions are non-secret.
 */
export interface PlatformVersions {
  termsVersion: string;
  privacyVersion: string;
  dpaVersion: string;
}

const BASE = '/api/v1/platform/config';

export const platformConfigService = {
  currentVersions: () => http.get<PlatformVersions>(`${BASE}/current-versions`),
};
